import { createTheme } from "@weave-brand/core/theme";
import { theme as marketing } from "@weave-brand/marketing/theme";

const WeaveBrandTheme = createTheme("brand", { extensions: [marketing] });

export default WeaveBrandTheme;
